import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Industries } from './components/Industries';
import { Pricing } from './components/Pricing';
import { Results } from './components/Results';
import { Footer } from './components/Footer';
import { motion, useScroll, useSpring } from 'framer-motion';
export function App() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="relative min-h-screen bg-brand-dark selection:bg-brand-accent selection:text-brand-dark" data-id="element-0">
      {/* Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-brand-accent z-[60] origin-left" style={{
      scaleX
    }} data-id="element-1" />

      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <Results data-id="element-7" />
        <Industries data-id="element-8" />
        <Pricing data-id="element-9" />

        {/* Final CTA Section */}
        <section className="py-24 relative overflow-hidden" data-id="element-10">
          <div className="container mx-auto px-6 text-center relative z-10" data-id="element-11">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="max-w-4xl mx-auto p-16 rounded-[3rem] bg-gradient-to-br from-brand-accent/20 to-transparent border border-brand-accent/20 backdrop-blur-sm" data-id="element-12">
              <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-8" data-id="element-13">
                Let’s Scale Your Business
              </h2>
              <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-14">
                Stop managing operations and start building your business. Book
                a 30-minute discovery call today.
              </p>
              <button className="bg-brand-accent text-brand-dark px-10 py-5 rounded-2xl font-black text-xl hover:bg-white transition-all transform hover:scale-105 shadow-2xl shadow-brand-accent/20" data-id="element-15">
                Book Discovery Call
              </button>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer data-id="element-16" />
    </div>;
}